import styled from '@emotion/styled';
import React from 'react';

import { color, font } from 'src/shared/styles/variables';

const listInstructions = [
    'Breathe in through your nose for 4 seconds ',
    'Hold your breath for 1 second',
    'Breathe out through your mouth for 6 seconds',
    'Pause for one second',
    'Repeat for 5 breaths',
];

const Instructions = styled('ol')({
    padding: '1rem',
});

const Instruction = styled('li')(
    {
        color: color.baliHai,
        '&:not(:last-child)': {
            marginBottom: '0.25rem',
        },
    },
    font.book(font.size.base),
);

export const RelaxationInstructions: React.SFC = () => (
    <Instructions>
        {listInstructions.map(instruction => (
            <Instruction key={instruction}>{instruction} </Instruction>
        ))}
    </Instructions>
);
